import {useState} from 'react';

const MultiOrgEmployeeList = ({
  locationData,
  adminData,
  searchTerm,
  onSearchChange,
}) => {
  const [expandedLocations, setExpandedLocations] = useState({});

  const toggleLocationExpansion = (location) => {
    setExpandedLocations((prev) => ({
      ...prev,
      [location]: !prev[location],
    }));
  };

  const getFilteredLocationData = () => {
    if (!searchTerm) return locationData;

    const filtered = {};
    Object.entries(locationData).forEach(([location, data]) => {
      const filteredEmployees = data.employees.filter((emp) =>
        emp.fullName.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      const filteredManagers = data.managers.filter((mgr) =>
        mgr.fullName.toLowerCase().includes(searchTerm.toLowerCase()),
      );

      if (filteredEmployees.length > 0 || filteredManagers.length > 0) {
        filtered[location] = {
          employees: filteredEmployees,
          managers: filteredManagers,
        };
      }
    });

    return filtered;
  };

  const getFilteredAdminData = () => {
    if (!searchTerm) return adminData;

    return adminData.filter((admin) =>
      admin.fullName.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  };

  return (
    <>
      <div className='section-header'>
        <h2>All Team Members</h2>
      </div>

      <div className='employee-search'>
        <input
          type='text'
          placeholder='Search team members'
          value={searchTerm}
          onChange={onSearchChange}
          className='search-input'
        />
      </div>

      <div className='admin-view-container'>
        <div className='section-subheader'>
          <h3>Locations</h3>
        </div>
        <div className='locations-container'>
          {Object.keys(getFilteredLocationData()).length > 0 ? (
            Object.entries(getFilteredLocationData()).map(
              ([location, data]) => (
                <div key={location} className='location-group'>
                  <div className='location-header'>{location}</div>

                  {data.managers.length > 0 && (
                    <div className='role-section'>
                      <div className='role-header'>Managers</div>
                      {data.managers.map((manager) => (
                        <div key={manager.id} className='person-item'>
                          <span className='person-icon manager-icon'>👔</span>
                          <span className='person-name'>
                            {manager.fullName}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}

                  {data.employees.length > 0 && (
                    <div className='role-section'>
                      <div className='role-header'>Employees</div>
                      {data.employees
                        .slice(
                          0,
                          expandedLocations[location]
                            ? data.employees.length
                            : 3,
                        )
                        .map((employee) => (
                          <div key={employee.id} className='person-item'>
                            <span className='person-icon employee-icon'>
                              👤
                            </span>
                            <span className='person-name'>
                              {employee.fullName}
                            </span>
                          </div>
                        ))}
                      {data.employees.length > 3 && (
                        <button
                          className='expand-button'
                          onClick={() => toggleLocationExpansion(location)}
                        >
                          {expandedLocations[location]
                            ? `Show less`
                            : `See all site employees (${data.employees.length - 3} more)`}
                        </button>
                      )}
                    </div>
                  )}

                  {data.managers.length === 0 &&
                    data.employees.length === 0 && (
                      <div className='empty-location'>
                        <span className='empty-icon'>🚫</span>
                        No team members in this location
                      </div>
                    )}
                </div>
              ),
            )
          ) : (
            <div className='no-results'>No locations found</div>
          )}
        </div>

        <div className='section-subheader'>
          <h3>Admins</h3>
        </div>
        <div className='admins-container'>
          {getFilteredAdminData().length > 0 ? (
            getFilteredAdminData().map((admin) => (
              <div key={admin.id} className='admin-item'>
                <span className='person-icon admin-icon'>🛡️</span>
                <div className='admin-info'>
                  <div className='admin-name'>{admin.fullName}</div>
                  <div className='admin-company'>{admin.companyName}</div>
                </div>
              </div>
            ))
          ) : (
            <div className='no-results'>No admins found</div>
          )}
        </div>
      </div>
    </>
  );
};

export default MultiOrgEmployeeList;
